import React ,{Component} from 'react';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { addDays } from "date-fns";
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox'; 
import FormControlLabel from '@mui/material/FormControlLabel'; 
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ReactToPrint from 'react-to-print';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
//import { styled } from '@mui/material/styles';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
	 import InfoSharpIcon from '@mui/icons-material/InfoSharp';          
 import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(100%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 100,
});
const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
  table: {
    minWidth: 750,
  },
});
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}
function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
 export default class  PaymentBoxAdd extends Component {
   constructor(props) {
      super(props)
	 	var strdob = new Date();
        var month = "";
      if ((strdob.getMonth() + 1) < 10) {
      month = "0" + (strdob.getMonth() + 1);
    } else {
      month = (strdob.getMonth() + 1);
    }
     this.state = { 
	 ledgerlabel:'Please select',
        open:false,
		payopen:false,  
		isDisabled: false ,ledger:'',
		pmt_paymentdate:Date.now(),
		pmt_discount:'0',
		pmt_paymentdate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),
      pmt_reference:'',ledgerdata:[],errormessage:'',erropen:false,errortype:"error",pmt_paymenttype:'',printremittance:false,remainingbal:0,
  }
   }
handleErrorclose=(event)=>{
	this.setState({erropen: false});  
  }
Oncloseicon =()=>{
  this.setState({payopen:!this.state.payopen,  
	  });
}
handleClickOpen = (e) => {
  this.setState({payopen:!this.state.payopen,  
	  });
	  this.ledgerbind();
};
refunddatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }
    this.setState({
        pmt_paymentdate: dayjs(dateObj),
        pmt_paymentdate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
}
onClickSalesSave= (event) => {
	if (parseFloat(this.state.Outstandingamt) > parseFloat(this.props.Grndtotal)) {
	 this.setState({errormessage:"Please enter amount less than or equal to oustanding amount",erropen:true,errortype:"error",});
		 window.scrollTo({top: 0})
		 return false;
    }
	 if(this.state.pmt_paymentdate1 === "")
	 {		 
		 this.setState({errormessage:"Please Select Refund Date",erropen:true,errortype:"error",});
		 window.scrollTo({top: 0})
		 return false;
	 }	
	 	 if(this.state.ledger === "")
	 {		 
		 this.setState({errormessage:"Please Select Ledger",erropen:true,errortype:"error",});
		 window.scrollTo({top: 0})
		 return false;
	 }	
	 	 	 if(this.state.pmt_paymenttype === "" || this.state.pmt_paymenttype === "0")
	 {		 
		 this.setState({errormessage:"Please Select Payment Method",erropen:true,errortype:"error",});
		 window.scrollTo({top: 0})
		 return false;
	 }	
	this.setState({btndisabled:true,submitbtn:"Processing..."})
      var formData = new FormData();
      formData.append('action','insert')
       formData.append('pmt_id',0) 
       formData.append('pmt_amount',this.state.Outstandingamt) 
       formData.append('pmt_paymentdate',this.state.pmt_paymentdate1) 
       formData.append('pmt_ledger_id',this.state.ledger) 
       formData.append('pmt_paymenttype',this.state.pmt_paymenttype) 
       formData.append('pmt_reference',this.state.pmt_reference) 
         if(this.state.printremittance===true){
       formData.append('pmt_printremittanceadvance',1) 
	   }
	   else{
		    formData.append('pmt_printremittanceadvance',0) 
	   }
       formData.append('pmt_type',this.props.pmt_type) 
       formData.append('pref_mainid',this.props.pref_mainid) 
	   formData.append('pmt_cmp_id',localStorage.getItem("ISIcmpid"))
	   formData.append('pmt_cu_id',this.props.cu_id)
	   if(this.state.pmt_discount!=="")
	   {
	   formData.append('pmt_discount',this.state.pmt_discount)
	   }else{
		 formData.append('pmt_discount',0)  
	   }
    formData.append('userid',localStorage.getItem("ISIuserid"))	
		 axios.post(localStorage.getItem("ISIurl")+"ajaxpayments.php", formData, {
        })
	.then(res => {
				this.setState({btndisabled:false,payopen:false,submitbtn:"Save",errortype:"success",errormessage:"Payment Inserted Successfully",erropen:true,pmt_reference:'',ledger:'',pmt_paymentdate1:'',pmt_paymenttype:'',})
			this.props.updateDonenew();
			})
}
 handledraft=(e)=>{
	this.setState({printremittance: !this.state.printremittance},()=>{
	}); 
 }
 myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  if (nam === "Outstandingamt") {
    this.setState({ [nam]: val },()=>{
		if (parseFloat(val) > parseFloat(this.props.Grndtotal)) {
	 this.setState({errormessage:"Please enter amount less than or equal to oustanding amount",erropen:true,errortype:"error",});
		 window.scrollTo({top: 0})
		 return false;
    }{
      let remaining = parseFloat(this.props.Grndtotal) - parseFloat(val)-parseFloat(this.state.pmt_discount);
      this.setState({ remainingbal: remaining });
    } 
	}
	);
  }if (nam === "pmt_discount") {
	  this.setState({ [nam]: val },()=>{
  let remaining = parseFloat(this.props.Grndtotal) - parseFloat(val);
   this.setState({ Outstandingamt: remaining, });
	  });		  
  }
  else{
  this.setState({ [nam]: val });
  }
}
    ledgerbind(){
    axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=getall&le_category=Bank&le_cmp_id='+localStorage.getItem("ISIcmpid")+'&le_isbank=1')
      .then((resp) => {   
	  let LedgerApi = resp.data.map(row => {
          return {value: row.le_id, display:row.le_code+" - "+row.le_ledgername}
        });
		 this.setState({
          ledgerdata: LedgerApi,ledger:resp.data[0]["le_id"]
        });
      })
}
  handleaAddpaymentClose = () => {
    this.setState({
      payopen: !this.state.payopen,   Outstandingamt:this.props.Grndtotal
    });
	this.ledgerbind();
  };
 render(){
  return (
   <React.Fragment>
<div className="checkbox">
<Dialog
  open={this.state.payopen}
  onClose={this.handleClose}
  maxWidth={false}
  PaperProps={{
    style: {
      width: '600px',  
      maxWidth: 'none' ,
	  backgroundColor:'#f2f5f6',
	  borderRadius: '15px'
    }
  }}
>
  <DialogTitle id="form-dialog-title" className="dialoghead">
    <h4><b>Record Refund</b></h4>
	<span onClick={this.Oncloseicon} className="closeicon">
	<CloseIcon/>
	</span>
  </DialogTitle>
<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
   <div className="refunddialogue">
  <DialogContent>
      <Table className="whitebg">
	  {(this.props.pmt_type===3 || this.props.pmt_type===1) && (
	  <tr>
          <td>Amount Paid:<br/>
		 Remaining balance $ {this.state.remainingbal}
		  </td>
          <td>
           <TextField
   variant="outlined"
   margin="normal"
   className="txtbox"
   value={this.state.Outstandingamt}
   id="Outstandingamt"
    name="Outstandingamt"  
     onChange={this.myChangeHandler}
  />
          </td>
	  </tr>
	  )}
	  {(this.props.pmt_type===2 || this.props.pmt_type===4) && (
        <tr>
          <td><span className="graytextcolor">Amount Refunded:</span></td>
          <td>
            <TextField
              variant="outlined"
              margin="normal"
              className="txtbox"
              value={this.props.Grndtotal}
              id="Grndtotal"
              name="Grndtotal"
			  onChange={this.myChangeHandler}
              disabled
            />
          </td>
        </tr>
	  )}
		 {(this.props.pmt_type===3 || this.props.pmt_type===1)&& (
		 <tr>
          <td>Discount</td>
          <td>
            <TextField
              variant="outlined"
              margin="normal"
              className="txtbox"
              value={this.state.pmt_discount}
              id="pmt_discount"
              name="pmt_discount"
			   onChange={this.myChangeHandler}
            />
          </td>
        </tr>
		 )}
      </Table>
      <Table className="whitebg">
        <tr>
          <td>Date refunded:</td>
          <td>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']}>
                <DatePicker
                  value={dayjs(this.state.pmt_paymentdate)}
                  onChange={this.refunddatehandler}
                  format="MM/DD/YYYY"
                  className="txtbox"
                />
              </DemoContainer>
            </LocalizationProvider>
          </td>
        </tr>
		<tr>
		<td><span className="validation">*</span> Paid into</td>
		<td>
<FormControl   className="txtbox">
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.ledgerlabel, value:this.state.ledger}}
          onChange={this.myChangeHandler}
          id="ledger"
		   value={this.state.ledger} className="txtbox"
		  name="ledger"
		inputProps={{tabIndex: "8"}}
        >
		{this.state.ledgerdata.map(ledger => (
            <option  
              value={ledger.value}
            >
              {ledger.display}
            </option  >
          ))}
        </Select></FormControl>
		</td>
		</tr>
        <tr>
          <td><span className="validation">*</span> Method:</td>
          <td>
            <Select
              native
              variant="outlined"
              className="txtbox"
              margin="normal"
              fullWidth
              onChange={this.myChangeHandler}
              id="pmt_paymenttype"
              value={this.state.pmt_paymenttype}
              name="pmt_paymenttype"
              inputProps={{ tabIndex: "4" }}
            >
              <option value={0}>Enter a Method</option>
              <option value={1}>Cash</option>
              <option value={2}>Check</option>
              <option value={3}>Electronic</option>
              <option value={4}>Credit/Debit Card</option>
              <option value={5}>Paypal</option>
            </Select>
          </td>
        </tr>
        <tr>
          <td>Reference (optional):</td>
          <td>
            <TextField
              variant="outlined"
              margin="normal"
              className="txtbox"
			  onChange={this.myChangeHandler}
              value={this.state.pmt_reference}
              id="pmt_reference"
              name="pmt_reference"
			      inputProps={{
				maxLength: 50
				}}
            />
          </td>
        </tr>
		{(this.props.pmt_type===3 || this.props.pmt_type===1) && (
		<tr>
          <td>Print remittance advice</td>
          <td>
          <Checkbox  value={this.state.printremittance}  checked={this.state.printremittance}  onChange={this.handledraft} color="default" /> 
          </td>
        </tr>
		)}
      </Table>
{(this.props.pmt_type===2 || this.props.pmt_type===4) && (
	  <Button variant="contained" className="refundcolor" onClick={this.onClickSalesSave}>
              Refund $ {this.state.Outstandingamt}
            </Button>
	   )}
	  {(this.props.pmt_type===3 || this.props.pmt_type===1)&& (
	  <Button variant="contained" className="refundcolor" onClick={this.onClickSalesSave}>
              Record $ {this.state.Outstandingamt}
            </Button>
	  )}
  </DialogContent> </div>
</Dialog>
  </div>
  </React.Fragment>
 )
 }
  }